import { useEffect, useRef } from 'react';

const useSubscriptionGate = ({
  user,
  hasActiveSubscription,
  isCheckoutRoute,
  isSubscriptionRequiredRoute,
  currentPath,
  navigate,
}) => {
  const hasRedirectedRef = useRef(false);
  useEffect(() => {
    if (isSubscriptionRequiredRoute) {
      hasRedirectedRef.current = true;
      return;
    }
    if (
      user &&
      hasActiveSubscription === false &&
      !isCheckoutRoute &&
      !hasRedirectedRef.current &&
      currentPath !== '/subscription-required'
    ) {
      hasRedirectedRef.current = true;
      navigate('/subscription-required', { replace: true });
    }
  }, [user, hasActiveSubscription, isCheckoutRoute, isSubscriptionRequiredRoute, currentPath, navigate]);
};

export default useSubscriptionGate;
